import type { FertilizationPlanAdvice, MaintenanceFoliarAnalysis } from '../types';
import {
	getMaintenanceReferenceName,
	getMaintenanceSectorNames,
} from '../utils/maintenanceAdviceMapper';
import type { PlanningSectorResult } from '../utils/planningTableMapper';

const MOCK_ADJUSTMENT_FACTORS = [1.15, 0.92, 1];

export const getMockFoliarAnalysis = (
	advice: FertilizationPlanAdvice
): MaintenanceFoliarAnalysis => ({
	id: 'mock-foliar-analysis',
	name: 'Folha_Ago-2026.pdf',
	isLatest: true,
	areaName: getMaintenanceReferenceName(advice.area, advice.areaName),
	sectorsLabel: getMaintenanceSectorNames(advice.sectors).join(', '),
	sampledAt: '2026-08-20',
	nutrients: {
		below: ['P', 'Mg', 'B', 'Zn'],
		adequate: ['N', 'Ca', 'S', 'Cu', 'Fe', 'Mn'],
		above: ['K'],
	},
});

export const mockAdjustDemand = (
	sectors: PlanningSectorResult[],
	periods: string[]
): Promise<PlanningSectorResult[]> => {
	const fertilizerIds: string[] = [];
	const factorFor = (id: string) => {
		if (!fertilizerIds.includes(id)) fertilizerIds.push(id);
		return MOCK_ADJUSTMENT_FACTORS[fertilizerIds.indexOf(id) % MOCK_ADJUSTMENT_FACTORS.length];
	};
	const adjusted = sectors.map((sector) => ({
		...sector,
		recommendations: (Array.isArray(sector.recommendations) ? sector.recommendations : []).map(
			(recommendation) =>
				recommendation.period && periods.includes(recommendation.period)
					? {
							...recommendation,
							proposal: (recommendation.proposal ?? []).map((item) => ({
								...item,
								dose: item.dose * factorFor(String(item.id)),
							})),
						}
					: recommendation
		),
	}));
	return new Promise((resolve) => setTimeout(() => resolve(adjusted), 600));
};
